export {default} from './Icon';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Icon/index.ts